// Local translations
export const T = {
  en_GB: {
    clients: "Clients",
    client: "Client",
    process: "Process",
    notFound: "This flow could not be found.",
  },
  nb_NO: {
    clients: "Kunder",
    client: "Kunde",
    process: "Prosess",
    notFound: "Fant ikke denne flyten.",
  },
} as const;
